var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('tableList',{ref:"list",on:{"modify":_vm.amodifyExpress}}),(_vm.showEdit)?_c('edit',{attrs:{"currentId":_vm.currentId},on:{"cancel":_vm.cancelExpress,"save":_vm.saveExpress}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }